const COLOURS = {
    White: "#FFFFFF",
    Black: "#000000",
    Grey: "#D6D6D6",
    LightGrey: "#F9F9F9",
    DarkGrey: "#D2D2D2",
};

export default COLOURS;
